import React, { useEffect, useState } from 'react';
import { fetchCourse } from '../../../services/courses';

const PreReqStatus = ({ course, className = '', slim }) => {
  const [prerequisite, setPrerequisite] = useState(null);
  // Course
  const prerequisiteId = course?.prerequisiteId || null;

  useEffect(() => {
    if (prerequisiteId && course?.id) {
      fetchCourse(prerequisiteId).then((rsp) => {
        setPrerequisite(rsp);
      });
    }
  }, [course?.id, prerequisiteId]);

  if (!course?.id || !course?.prerequisiteId) {
    return null;
  }

  if (slim) {
    return (
      <div className="text-muted">
        <b>Prereq:</b> {prerequisite?.title}
      </div>
    );
  }

  return (
    <div className={className}>
      <b>Prerequisite:</b>
      <p className="text-muted mt-1 mb-0 d-flex align-items-center">
        {prerequisite?.title}
      </p>
    </div>
  );
};

export default PreReqStatus;
